module.exports = __webpack_public_path__ + "static/IG-2502ed69a6ce8b90d0a03e5030167014.png";